/** Restore UI selection from the persisted server result, without issuing an attempt. */
export function replayAnswer(result:any){
 const n=result?.normalizedResult;if(!n)return null;
 if(n.selectedChoiceId!==undefined)return {selectedChoiceId:String(n.selectedChoiceId)};
 if(n.selectedSceneId!==undefined||n.sceneId!==undefined)return {sceneId:String(n.selectedSceneId??n.sceneId)};
 if(n.pairs)return {pairs:n.pairs};
 if(n.tones)return {tones:n.tones};
 if(n.orderedTokenIds)return {orderedTokenIds:n.orderedTokenIds};
 if(n.selectedChoiceIds)return {selectedChoiceIds:n.selectedChoiceIds};
 return n;
}
export function redundantInstruction(title:unknown,prompt:unknown){return String(title??'').trim().replace(/[.!?…]$/,'').toLowerCase()===String(prompt??'').trim().replace(/[.!?…]$/,'').toLowerCase();}
